import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useMap } from "react-leaflet";

import { NameID } from "../../../../../types/NameID";

type ChartBarLike = {
  label: NameID;
  count: number;
};

type Props = {
  data: { area: NameID; bars: ChartBarLike[] }[];
  selectedAreaId?: number;
  onAreaClicked?: (areaId: number) => void;
};

// その他を枠外に表示する
export const OtherCountControl = ({
  data,
  selectedAreaId,
  onAreaClicked,
}: Props): JSX.Element | null => {
  const map = useMap();
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    const corner = map
      .getContainer()
      .querySelector(".leaflet-top.leaflet-right") as HTMLElement | null;
    if (!corner) return;
    const div = document.createElement("div");
    div.className = "chart-others-root";
    corner.appendChild(div);
    setContainer(div);
    return () => {
      div.remove();
      setContainer(null);
    };
  }, [map]);

  if (!container) return null;

  const activateArea = (areaId: number) => {
    onAreaClicked?.(areaId);
  };

  const summarySections = data.flatMap((x) => {
    if (x.bars.length === 0) return [];

    const total = x.bars.reduce((sum, bar) => sum + bar.count, 0);
    const isSelected = selectedAreaId === x.area.id;

    return [
      <div
        key={`others-${x.area.id}`}
        className={`leaflet-control chart-others-back${isSelected ? " is-selected" : ""}`}
        role="button"
        tabIndex={0}
        aria-pressed={isSelected}
        onKeyDown={(e) => {
          if (e.key !== "Enter" && e.key !== " ") return;
          e.preventDefault();
          e.stopPropagation();
          activateArea(x.area.id);
        }}
        onClick={(e) => {
          e.stopPropagation();
          activateArea(x.area.id);
        }}
      >
        <div className="chart-others-section">
          <div className="chart-others-title">{`${x.area.name}: ${total}件`}</div>
          <hr style={{ marginTop: "0.25rem", marginBottom: "0.5rem" }} />
          <table className="chart-others-table">
            <tbody>
              {x.bars.map((bar) => (
                <tr key={bar.label.id}>
                  <td>{bar.label.name}</td>
                  <td>{bar.count}件</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>,
    ];
  });

  return ReactDOM.createPortal(<>{summarySections}</>, container) as unknown as JSX.Element;
};
